function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M472,0H8C3.582,0,0,3.582,0,8v432c0,4.418,3.582,8,8,8h24v24c0,4.418,3.582,8,8,8h400c4.418,0,8-3.582,8-8v-24h24 c4.418,0,8-3.582,8-8V8C480,3.582,476.418,0,472,0z M432,464H48v-16h384V464z M464,432H16V16h448V432z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M408,96H72c-22.08,0.026-39.974,17.92-40,40v232c0.026,22.08,17.92,39.974,40,40h336c22.08-0.026,39.974-17.92,40-40V136 C447.974,113.92,430.08,96.026,408,96z M72.208,328H72c-4.418,0-8,3.582-8,8c0.029,8.684,2.914,17.117,8.208,24H72 c-4.418,0-8,3.582-8,8c0.029,8.684,2.914,17.117,8.208,24H72c-13.255,0-24-10.745-24-24V136c0-13.255,10.745-24,24-24h336 c13.255,0,24,10.745,24,24v72.136c-29.151-54.78-91.676-82.893-152-68.344V128h-80v48h15.76 c-23.446,23.544-37.498,54.834-39.52,88H160v-80h-24v-24h24v-16H96v16h24v24H96v80H72c-4.418,0-8,3.582-8,8 c0.029,8.684,2.914,17.117,8.208,24H72c-4.418,0-8,3.582-8,8C64.029,312.684,66.914,321.117,72.208,328z M264,144v16h-48v-16H264z  M144,200v64h-32v-64H144z M296,392H104c-10.168-0.012-19.229-6.418-22.632-16h237.264C315.229,385.582,306.168,391.988,296,392z  M296,360H104c-10.168-0.012-19.229-6.418-22.632-16h237.264C315.229,353.582,306.168,359.988,296,360z M296,328H104 c-10.168-0.012-19.229-6.418-22.632-16h237.264C315.229,321.582,306.168,327.988,296,328z M296,296H104 c-10.168-0.012-19.229-6.418-22.632-16h237.264C315.229,289.582,306.168,295.988,296,296z M327.792,328 c5.294-6.883,8.179-15.316,8.208-24c0-4.418-3.582-8-8-8h-0.208c5.294-6.883,8.179-15.316,8.208-24c0-4.418-3.582-8-8-8h-95.592 c4.396-43.964,43.599-76.039,87.563-71.643c43.964,4.396,76.039,43.599,71.643,87.563c-3.275,32.75-26.273,60.151-57.958,69.056 c1.503-4.164,2.295-8.55,2.344-12.976c0-4.418-3.582-8-8-8H327.792z M432,368c0,13.255-10.745,24-24,24h-32.136 c23.845-12.757,43.379-32.291,56.136-56.136V368z M344.222,387.473c-5.034,1.399-10.153,2.468-15.326,3.199 c4.622-6.657,7.101-14.568,7.104-22.672c-0.012-0.996-0.21-1.981-0.584-2.904c51.428-12.89,82.67-65.031,69.78-116.459 c-12.89-51.429-65.031-82.67-116.459-69.78c-39.841,9.986-68.915,44.212-72.328,85.143H192.48 c2.353-34.873,19.767-66.996,47.704-88H280v-19.592c63.807-17.734,129.909,19.615,147.644,83.422 C445.378,303.636,408.029,369.739,344.222,387.473z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M104,32H40c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8V40C112,35.582,108.418,32,104,32z M96,64 H48V48h48V64z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M200,32h-64c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8V40C208,35.582,204.418,32,200,32z  M192,64h-48V48h48V64z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 32,
  width: 16,
  height: 48
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 400,
  y: 32,
  width: 16,
  height: 48
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 368,
  y: 32,
  width: 16,
  height: 48
})));

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

function Svg78(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg78);
export default __webpack_public_path__ + "static/media/7_8.16fcae42.svg";
export { ForwardRef as ReactComponent };